module.exports = __webpack_public_path__ + "static/media/check_save.60c6c2cb.svg";